const sigils = {
  'USD': '$',
  'CAD': 'C$',
  'GBP': '£',
  'EUR': '­€',
  'MXN': '$',
  'BRL': 'R$',
  'AUD': '$',
  'HKD': '$'
};

export default sigils;
